<template>
  <div class="exportModel">
 
    <div class="model-title">
      <div><h2>仪器设备出入库登记表</h2></div>
      <div class="my-buttom tit-button" @click="derive">导出</div>
    </div>
    <template v-if="deviceType==1">
    <div class="model-detail">
      <!-- <div class="box-detail">
        <span class="box-title">项目名称：</span>
        <span class="box-content">{{dataDetail.projectName}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">领用日期：</span>
        <span class="box-content">{{dataDetail.lendCloseTime}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">归还日期：</span>
        <span class="box-content">{{dataDetail.returnCloseTime}}</span>
      </div> -->
      <div class="box-detail">
        <span class="box-title">领用部门：</span>
        <span class="box-content">{{dataDetail.deptNum}}</span>
      </div>
    </div>
    <div>
      <span class="box-title" style="margin-left: 10px;margin-bottom: 10px;">使用日期范围：</span>
      <el-date-picker format="yyyy-MM-dd" size="mini" value-format="yyyy-MM-dd" v-model="date" type="daterange" range-separator="至"
                       start-placeholder="开始日期" end-placeholder="结束日期">
       </el-date-picker>
       <el-button type="primary" size="mini"  @click="search">搜索</el-button>
    </div>
  </template>
    <div class="model-use-his sysTable" style="margin-top: 10px;">
      <template v-if="deviceType==1">
      <el-table
        :data="dataDetail.insUseInfos"
        height="500"
        v-loading="tLoading"
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="instrumentName"
          label="仪器名称"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="serialNumber"
          label="仪器编号"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column align="center" label="出库领用记录">
          <el-table-column
            prop="lendCloseTime"
            label="领用时间"
            align="center"
            width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.lendCloseTime">
                {{scope.row.lendCloseTime}}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="beforeUseStates"
            width="120"
            align="center"
            label="仪器状态/正常√ 异常×"
            :render-header="renderheader">
            <template slot-scope="scope">
              <span v-if="scope.row.beforeUseStates == 0">
                <i class="el-icon-check"></i>
              </span>
              <span v-else>
                <i class="el-icon-close"></i>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="borrowSignature"
            width="100"
            align="center"
            label="领用人">
            <template slot-scope="scope">
              <span v-if="scope.row.borrowSignature">
                <img :src="scope.row.borrowSignature" alt="">
              </span>
              <span>
                {{scope.row.borrowUserName}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="checkUser"
            width="120"
            align="center"
            label="仪器房经手人">
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="入库归还记录">
          <el-table-column
            prop="returnCloseTime"
            label="归还时间"
            align="center"
            width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.returnCloseTime">
                {{scope.row.returnCloseTime}}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="afterUseStates"
            width="120"
            align="center"
            label="仪器状态/正常√ 异常×"
            :render-header="renderheader">
            <template slot-scope="scope">
              <span v-if="scope.row.afterUseStates == 0">
                <i class="el-icon-check"></i>
              </span>
              <span v-else>
                <i class="el-icon-close"></i>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="returnSignatur"
            width="100"
            align="center"
            label="归还人">
            <template slot-scope="scope">
              <span v-if="scope.row.returnSignatur">
                <img :src="scope.row.returnSignatur" alt="">
              </span>
              <span>
                {{scope.row.returnUser}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="checkUser"
            width="120"
            align="center"
            label="仪器房经手人">
          </el-table-column>
        </el-table-column>
      </el-table>
    </template>
    <template v-if="deviceType==2">
      <el-table
        :data="instrumentRecord"
        height="500px"
        v-loading="tLoading"
        style="width: 100%">
        <el-table-column
          prop="insName"
          label="设备名称"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="insNumber"
          label="设备编号"
          align="center"
      >
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
         >
        </el-table-column>
        <el-table-column
          prop="beforeTime"
          label="使用开始时间"
          align="center"
         >
        </el-table-column>
        <el-table-column
          prop="afterTime"
          label="使用结束时间"
          align="center"
         >
        </el-table-column>
        <el-table-column
          prop="usingInfo"
          label="备注"
          align="center"
         >
        </el-table-column>
        <el-table-column
          prop="userName"
          label="使用人"
          align="center"
         >
        </el-table-column>
      </el-table>
    </template>
    </div>

  </div>
</template>

<script>
  import { getRecordByUse,getFixedUseInfoList } from "@/api/depotApi";
  import { exAppList,exportFixedByApply } from "@/api/dataMana.js"
  export default {
    name: "exportModel",
    props:{
      instrumentId:Number,
      useId:Number,
      deviceType:Number,
    },
    
    data(){
      return{
        date:null,
        dataDetail:{},
        tLoading:true,
        instrumentRecord:[]
      }
    },
    created() {

    },
    mounted() {
      this.getRecordByUse();
      this.getFixedUseInfoList()
    },
    watch:{
      useId(){
        this.getRecordByUse();
        this.getFixedUseInfoList()
      },
      instrumentId(){
        this.getFixedUseInfoList()
      }
    },
    methods:{
      search(){
        this.getRecordByUse();
        this.getFixedUseInfoList()
      },
      //获取使用记录
      getRecordByUse(){
        if(this.deviceType ==2) return
        let self = this;
        self.tLoading = true;
        let data = {
          applyId:self.useId
        };
        if (this.date) {
          data.startDate = this.date[0]
          data.endDate = this.date[1]
            }
        getRecordByUse(data).then((res) => {
          if (res.code == 200) {
            self.dataDetail = res.data;
          }
        }).finally(() => self.tLoading = false)
      },
          //获取固定使用记录
          getFixedUseInfoList(){
            if(!this.useId||!this.instrumentId||this.deviceType==1) return
        let self = this;
        self.tLoading = true;
        let data = {
          states:3,
          useApplicationId: this.useId,
          InsId: this.instrumentId,
        };
        if (this.date) {
          data.startDate = this.date[0]
          data.endDate = this.date[1]
            }
        getFixedUseInfoList(data).then((res) => {
          if (res.code == 200) {
            self.instrumentRecord = res.data;
          }
        }).finally(() => self.tLoading = false)
      },
      //导出使用记录
     async derive() {
        const params = {
          applyId: this.useId,
         startDate :this.date&&this.date.length?this.date[0]:'',
         endDate:this.date&&this.date.length?this.date[1]:''
        }
        const  res  =  this.deviceType==1? await exAppList(params): await exportFixedByApply(params)
          this.mixin.blobDownload(res.data,'仪器设备出入库登记表.zip');
      },
      renderheader(h, { column, $index }) {
        return h('span', {}, [
          h('span', {}, column.label.split('/')[0]),
          h('br'),
          h('span', {}, column.label.split('/')[1])
        ])
      },
    }
  }
</script>

<style lang="less" scoped>
  /*@import "~@/assets/css/myTableStyle.less";*/
  .exportModel{
    /*color: #74c8fe;*/
    .model-title{
      text-align: center;
      margin-bottom: 3%;
      .tit-button{
        float: right;
        margin-right: 1%;
      }
    }
    .model-detail{
      width: 100%;
      display: grid;//网格形式
      grid-template-columns:  45% 45%;//这里表明分为3列
      grid-gap: 10px;//每列的间隔
      margin-bottom: 20px;
      .box-detail{
        height: 32px;
        line-height: 32px;
        padding: 6px 12px;
        /*box-shadow: 0 0 15px #0071f1 inset;*/
        border-radius: 6px;
        margin-right: 10px;
        .box-title{
          width: 35%;
        }
        .box-content{
          width: 65%;
        }
      }
    }
  
    .model-bottom{
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Datamanagement/Applicationmana/components/exportModel.vue